import { render, staticRenderFns } from "./AlertDestinationCreateScreen.vue?vue&type=template&id=709f38d8&scoped=true&lang=pug"
import script from "./AlertDestinationCreateScreen.vue?vue&type=script&lang=ts"
export * from "./AlertDestinationCreateScreen.vue?vue&type=script&lang=ts"
import style0 from "./AlertDestinationCreateScreen.vue?vue&type=style&index=0&id=709f38d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709f38d8",
  null
  
)

export default component.exports